import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./Button";
import "./styles/PaymentFailed.css";
import { NavSections } from "../common/nav-sections";
import { AppRoutes } from "../common/app-routes";
import SEO from "./SEO";

interface PaymentFailedProps {
  changeActiveSection: (id: string) => void;
}

const PaymentFailed: React.FC<PaymentFailedProps> = ({ changeActiveSection }) => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Payment Failed – Cutora"
        description="Something went wrong while processing your payment. Please try again or contact support."
      />
      <div className="payment-status-container">
        <div className="payment-status-content">
          <h1 className="payment-status-title">Payment Failed ❌</h1>
          <p className="payment-status-message">
            Oops! Something went wrong while processing your payment.
          </p>
          <Button className="btn-default" onClick={() => {
            navigate(AppRoutes.HOME);
            changeActiveSection(NavSections.WELCOME);
          }}>
            Go to Home
          </Button>
        </div>
      </div>
    </>
  );
};

export default PaymentFailed;
